/**
 * Toll Services for FlowRide Frontend
 * Handles toll calculation API calls for route cost estimation.
 * Communicates with the backend toll service to get route costs.
 */

import axios from "axios";

interface TollRouteResponse {
    "cost":      string | number;
    "distance"?: number;
}

export class TollServices {

    /**
     * Calculate toll route information between two points
     * @param fromLat - Starting point latitude
     * @param fromLng - Starting point longitude
     * @param toLat - Destination point latitude
     * @param toLng - Destination point longitude
     * @returns Promise with toll route data including cost and route details
     */
    async calculateTollRoute( fromLat: number, fromLng: number, toLat: number, toLng: number ): Promise<TollRouteResponse> {
        try {
            const response = await axios.post<TollRouteResponse>( "/api/toll/route", {
                fromLat,
                fromLng,
                toLat,
                toLng,
            } );

            return response.data;
        } catch( error ) {
            console.error( "Error calculating toll route:", error );

            throw error;
        }
    }

    /**
     * Calculate toll cost between two points
     * @param fromLat - Starting point latitude
     * @param fromLng - Starting point longitude
     * @param toLat - Destination point latitude
     * @param toLng - Destination point longitude
     * @returns Promise with toll cost as a number
     */
    async calculateToll( fromLat: number, fromLng: number, toLat: number, toLng: number ): Promise<number> {
        try {
            const response = await this.calculateTollRoute( fromLat, fromLng, toLat, toLng );

            return parseFloat( String( response.cost ) );
        } catch( error ) {
            console.error( "Error calculating toll:", error );

            throw error;
        }
    }

}
